var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { PureComponent } from 'react';
import * as PropTypes from 'prop-types';
import { formatTime, classNames, styleName } from '../../utils/utils';
var NoImage = /** @class */ (function (_super) {
    __extends(NoImage, _super);
    function NoImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoImage.prototype.render = function () {
        var _a = this.props, item = _a.item, url = _a.url, pinglunUrl = _a.pinglunUrl, isDisplaySource = _a.isDisplaySource, isCount = _a.isCount, countMapCache = _a.countMapCache, searchPathMap = _a.searchPathMap;
        var isSource = isDisplaySource && !!item.source && item.source !== '';
        return (React.createElement("li", { className: classNames(styleName('newsStream-news-item-no-image'), 'clearfix', 'news_item'), "data-id": item.id },
            React.createElement("div", { className: styleName('newsStream-news-item-infor') },
                React.createElement("h2", { className: classNames(styleName('newsStream-news-item-title'), styleName('newsStream-news-item-title-height')) },
                    React.createElement("a", { href: url, title: item.title, target: "_blank", dangerouslySetInnerHTML: { __html: item.title } })),
                React.createElement("div", { className: "clearfix" },
                    item.searchPath && searchPathMap[item.searchPath] ? (React.createElement("span", { className: classNames(styleName('newsStream-mr10'), styleName('newsStream-text'), styleName('newsStream-searchPath')) }, searchPathMap[item.searchPath])) : null,
                    isSource ? (React.createElement("span", { className: classNames(styleName('newsStream-mr10'), styleName('newsStream-text')) }, item.source)) : null,
                    item.newsTime ? (React.createElement("time", { className: styleName('newsStream-text') }, formatTime(item.newsTime))) : null,
                    isCount ? (React.createElement("a", { className: classNames(styleName('newsStream-ly'), 'ly'), id: "count" + item.id, href: pinglunUrl, target: "_blank" }, ((item.commentUrl || item.guid) && countMapCache && countMapCache[item.id]) || 0)) : null))));
    };
    NoImage.propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        pinglunUrl: PropTypes.string,
        isDisplaySource: PropTypes.bool,
        isCount: PropTypes.bool
    };
    return NoImage;
}(PureComponent));
export default NoImage;
